import { useQuery } from 'react-query'
import { Article } from '../types/entities'
import { zendeskAPI } from '../config/routes'
import { QueryKeys } from '../api/queryKeys'
import { fetchData } from '../utils'

interface SectionArticlesResponse {
  articles: Article[]
}

type FetchSectionArticlesResult = {
  sectionArticlesError: unknown,
  isSectionArticlesFetching: boolean,
  sectionArticlesResponse: SectionArticlesResponse | undefined,
}

const useFetchSectionArticles = (sectionId: string): FetchSectionArticlesResult => {
  const queryKeys = [QueryKeys.ARTICLES_IN_SECTION, sectionId]

  const {
    error: sectionArticlesError,
    data: sectionArticlesResponse,
    isLoading: isSectionArticlesFetching,
  } = useQuery(
    queryKeys,
    () => fetchData(zendeskAPI.sectionArticles(sectionId)),
  )

  return {
    isSectionArticlesFetching,
    sectionArticlesError,
    sectionArticlesResponse,
  }
}

export { useFetchSectionArticles }
export type { FetchSectionArticlesResult }
